import { __exports as legal } from './_virtual-legal.js';
import { __require as requireContainer } from './vp-js-token-engine-build-infrastructure-container.js';
import { __require as requireLiveSiteClient } from './vp-js-token-engine-build-services-liveSiteClient.js';

var hasRequiredLegal;

function requireLegal () {
	if (hasRequiredLegal) return legal;
	hasRequiredLegal = 1;

	Object.defineProperty(legal, "__esModule", {
	  value: true
	});
	legal.filter = filter;
	legal.name = void 0;
	var _container = requireContainer();
	var _liveSiteClient = requireLiveSiteClient();
	const name = legal.name = 'legal';
	async function filter(path) {
	  const culture = _container.contextService.getCulture(this);
	  const tenant = _container.contextService.getTenant(this);
	  if (!tenant) {
	    throw new Error('tenant not set');
	  }
	  if (!culture) {
	    throw new Error('culture not set');
	  }
	  try {
	    const host = await (0, _liveSiteClient.getHost)(culture, tenant);
	    return "".concat(host, "/").concat(name, "/").concat(path);
	  } catch (e) {
	    return '#';
	  }
	}
	
	return legal;
}

export { requireLegal as __require };
//# sourceMappingURL=vp-js-token-engine-build-filters-legal.js.map
